<template>
    <q-card class="producto-equipo-form" style="max-width: 100vw; height: 90vh; display: flex; flex-direction: column;">
        <!-- Header mejorado - FIJO -->
        <q-toolbar class="bg-gradient-primary text-white toolbar-fixed">
            <q-icon name="precision_manufacturing" size="28px" class="q-mr-sm" />
            <q-toolbar-title>
                <div class="text-h6 capitalize">{{ title }}</div>
                <div class="text-caption text-white-7">{{ producto.productoDesc }}</div>
            </q-toolbar-title>

            <!-- Badge de validación -->
            <q-badge
                :color="res.valid ? 'positive' : 'warning'"
                :label="res.valid ? 'Válido' : 'Incompleto'"
                class="q-mr-md"
            >
                <q-icon
                    :name="res.valid ? 'check_circle' : 'error'"
                    size="16px"
                    class="q-ml-xs"
                />
            </q-badge>

            <q-btn dense flat icon="close" v-close-popup>
                <q-tooltip>Cerrar (ESC)</q-tooltip>
            </q-btn>
        </q-toolbar>

        <!-- Contenido scrolleable -->
        <div class="row no-wrap content-scrollable">
            <!-- Columna principal: Formulario -->
            <div class="col-12 col-md-8 q-pa-md scroll-area">
                <!-- Sección: Imagen del producto -->
                <q-card flat bordered class="q-mb-md producto-equipo-form__image-section">
                    <q-card-section class="q-pa-none relative-position">
                        <q-img
                            :src="imgSrc"
                            alt="product image"
                            fit="contain"
                            style="height: 200px; cursor: pointer;"
                            :placeholder-src="noImagePath"
                            @click="imageUpdate"
                            class="rounded-borders"
                        >
                            <template v-slot:error>
                                <div class="full-width full-height column items-center justify-center bg-grey-2">
                                    <q-icon name="broken_image" size="64px" color="grey-5" />
                                    <span class="text-caption text-grey-6 q-mt-xs">Sin imagen disponible</span>
                                </div>
                            </template>
                            <div class="absolute-bottom text-center bg-black-5 backdrop-blur">
                                <q-btn
                                    flat
                                    dense
                                    icon="photo_camera"
                                    label="Cambiar imagen"
                                    color="white"
                                    size="sm"
                                    @click.stop="imageUpdate"
                                />
                            </div>
                        </q-img>
                        <input
                            type="file"
                            ref="image"
                            style="display: none"
                            @change="onImageChange"
                        />
                    </q-card-section>
                </q-card>

                <!-- Sección: Información del Producto -->
                <q-expansion-item
                    default-opened
                    icon="info"
                    label="Información del Producto"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden"
                >
                    <q-card flat bordered>
                        <q-card-section>
                            <ProductosCommon
                                v-model:empresa-id="form.empresa_id"
                                v-model:alicuota-id="form.alicuota_id"
                                v-model:producto-id="form.producto_id"
                                v-model:tipo-venta-id="form.tipo_venta_id"
                                v-model:ubicacion-id="form.ubicacion_id"
                                @update:empresa-id="validate($event, 'empresa_id')"
                                @update:alicuota-id="validate($event, 'alicuota_id')"
                                @update:producto-id="validate($event, 'producto_id')"
                                @update:tipo-venta-id="validate($event, 'tipo_venta_id')"
                                @update:ubicacion-id="validate($event, 'ubicacion_id')"
                                :res="res"
                            />
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Cantidad y Precio -->
                <q-expansion-item
                    default-opened
                    icon="payments"
                    label="Cantidad y Precio"
                    caption="Configure precio, cantidad y descuentos"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden"
                >
                    <q-card flat bordered>
                        <q-card-section>
                            <div class="row q-col-gutter-md">
                                <div class="col-12 col-md-6">
                                    <GltnInputNumber
                                        name="Precio Unitario"
                                        :model-value="form.precio_unitario"
                                        hide-hint
                                        prefix="US$"
                                        label="Precio Unitario"
                                        readonly
                                        filled
                                        bg-color="green-1"
                                        @update:model-value="validate($event, 'ancho')"
                                        :errors="res.getErrors('ancho')"
                                    >
                                        <template v-slot:prepend>
                                            <q-icon name="attach_money" color="positive" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-md-6">
                                    <GltnInputNumber
                                        name="cantidad"
                                        type="number"
                                        v-model.number="form.cantidad"
                                        label="Cantidad"
                                        @update:model-value="validate($event, 'cantidad')"
                                        :errors="res.getErrors('cantidad')"
                                    >
                                        <template v-slot:prepend>
                                            <q-icon name="format_list_numbered" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-md-6">
                                    <GltnInputNumber
                                        v-model.number="form.descuento_comercial"
                                        label="Descuento comercial"
                                        suffix="%"
                                        @update:model-value="
                                            validate($event, 'descuento_comercial')
                                        "
                                        :errors="res.getErrors('descuento_comercial')"
                                    >
                                        <template v-slot:prepend>
                                            <q-icon name="local_offer" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-md-6" v-if="canShowEstrategico">
                                    <GltnInputNumber
                                        v-model.number="form.descuento_estrategico"
                                        label="Descuento estratégico"
                                        suffix="%"
                                        @update:model-value="
                                            validate($event, 'descuento_estrategico')
                                        "
                                        :errors="res.getErrors('descuento_estrategico')"
                                    >
                                        <template v-slot:prepend>
                                            <q-icon name="star" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Accesorios -->
                <q-expansion-item
                    default-opened
                    icon="build_circle"
                    :label="`Accesorios (${form.accesorios.length})`"
                    :caption="form.accesorios.length > 0 ? `Total accesorios: ${totalAccesoriosFormatted}` : 'Sin accesorios agregados'"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden"
                >
                    <q-card flat bordered>
                        <q-card-section>
                            <ProductoEquipoAcc :items="form.accesorios" />
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Observaciones -->
                <q-expansion-item
                    icon="notes"
                    label="Observaciones"
                    caption="Agregue notas adicionales (opcional)"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="rounded-borders overflow-hidden"
                >
                    <q-card flat bordered>
                        <q-card-section>
                            <GltnInput
                                v-model="form.observaciones"
                                label="Observaciones"
                                type="textarea"
                                rows="3"
                                hint="Información adicional sobre este equipo"
                            >
                                <template v-slot:prepend>
                                    <q-icon name="comment" />
                                </template>
                            </GltnInput>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
            </div>

            <!-- Columna lateral: Resumen -->
            <ProductoResumen
                type="equipo"
                :form="form"
                :producto="producto"
                :total-accesorios="totalAccesoriosFormatted"
                :accesorios="form.accesorios"
                :validation-progress="validationProgress"
                :validation-progress-text="validationProgressText"
            >
                <template #after-card>
                    <ProductoResumenTips>
                        <li>Presiona <kbd>Ctrl + S</kbd> para guardar</li>
                        <li>Los accesorios se suman al total</li>
                        <li>Los descuentos se aplican antes de los accesorios</li>
                    </ProductoResumenTips>
                </template>
            </ProductoResumen>
        </div>

        <!-- Footer con acciones - FIJO -->
        <q-separator />
        <q-card-actions class="q-pa-md actions-fixed bg-white">
            <div class="row full-width q-gutter-sm">
                <div class="col">
                    <q-btn
                        outline
                        label="Cancelar"
                        color="grey-7"
                        icon="close"
                        v-close-popup
                        class="full-width"
                    />
                </div>
                <div class="col" v-if="props.oper !== 'view'">
                    <q-btn
                        unelevated
                        :label="props.oper === 'add' ? 'Agregar al carrito' : 'Actualizar'"
                        :color="res.valid ? 'primary' : 'grey'"
                        :icon="props.oper === 'add' ? 'add_shopping_cart' : 'save'"
                        @click="cartSave"
                        :disable="!res.valid"

                        class="full-width"
                    >
                    </q-btn>
                </div>
            </div>
        </q-card-actions>


    </q-card>
</template>

<script setup>

import { computed, reactive, ref, onMounted, onUnmounted } from "vue";
import { round } from "mathjs";
import { useCartStore } from "@/stores/useCartStore.js";
import { useImageUploader } from "@/composables/useImageUploader";
import { usePage } from "@inertiajs/vue3";
import { usePrecioCalc } from "@/composables/usePrecioCalc";
import GltnInput from "@/components/form/GltnInput.vue";
import GltnInputNumber from "@/components/form/GltnInputNumber.vue";
import ProductoEquipoAcc from "./ProductoEquipoAcc.vue";
import ProductoResumen from "../ProductoResumen.vue";
import ProductoResumenTips from "../ProductoResumenTips.vue";
import ProductosCommon from "./components/ProductosCommon.vue";
import suite from "./ProductoEquipoValidation.js";
import { useProductoTitle } from "@/composables/useProductoTitle.js";

const page = usePage();
const productosImagesPath = page.props.productosImagesPath;
const noImagePath = page.props.noImagePath;
const imgSrc = computed(
    () =>
        `${productosImagesPath}/${props.producto.productoID}.webp?${random.value}` // Use random to force reload image`
);

const canShowEstrategico = computed(() => page.props?.auth?.can.includes('presupuesto.item.estrategico'));
const props = defineProps({
    oper: String,
    producto: Object,
    formulario: Object,
    presupId: Number,
    isSavedPresup: {
        type: Boolean,
        default: false,
    },
});
const emits = defineEmits(["added", "updated"]);
const form = reactive({
    cantidad: "",
    precio_unitario: round(props.producto.precio, 2),
    descuento_comercial: 0,
    descuento_estrategico: 0,
    descuento_monto: 0,
    subtotal: "",
    total: "",
    empresa_id: "",
    alicuota_id: 2,
    tipo_venta_id: "",
    accesorios: [],
    ubicacion_id: "",
});
// TITULO
const title = useProductoTitle(props.oper, 'equipo');
// VALIDACION
const res = ref();
res.value = suite.get();
const validate = (value, name) => {
    res.value = suite(name, form);
};

// Progress de validación
const validationProgress = computed(() => {
    const requiredFields = ['empresa_id', 'alicuota_id', 'tipo_venta_id', 'cantidad', 'ubicacion_id'];
    const completed = requiredFields.filter(field => {
        const value = form[field];
        return value !== '' && value !== null && value !== undefined;
    }).length;
    return completed / requiredFields.length;
});

const validationProgressText = computed(() => {
    const percent = Math.round(validationProgress.value * 100);
    return `Formulario ${percent}% completo`;
});

const setValues = () => {
    for (let key in props.formulario) {
        form[key] = props.formulario[key];
    }
};

onMounted(() => {
    if (props.oper === "edit" || props.oper === 'view') {
        setValues();
    }
    validate();

    // Agregar keyboard shortcut
    document.addEventListener('keydown', handleKeyboardShortcut);
});

onUnmounted(() => {
    document.removeEventListener('keydown', handleKeyboardShortcut);
});

const handleKeyboardShortcut = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        e.preventDefault();
        if (res.valid) {
            cartSave();
        }
    }
};

const {
    total,
    subtotal,
    precio_unitario,
    descuento_comercial,
    descuento_estrategico,
    totalAccesoriosFormatted,
} = usePrecioCalc(form);

// GESTION DE CART
const cartStore = useCartStore();
//const loading = computed(() => cartStore.getLoadingStatus());
const cartSave = () => {
    if (props.oper === "add") {
        cartAdd();
    } else {
        cartUpdate();
    }
};
const cartAdd = async () => {
    await cartStore.itemAdd(
        {
            form: { ...form },
            producto: { ...props.producto },
        },
        props.isSavedPresup,
        props.presupId
    );
    emits("added");
};
const cartUpdate = async () => {
    await cartStore.itemUpdate(
        {
            form: { ...form },
            producto: { ...props.producto },
        },
        props.isSavedPresup,
        props.presupId
    );
    emits("updated");
};
const { image, onImageChange, imageUpdate, random } = useImageUploader(
    form,
    props
);
</script>

<style lang="scss" scoped>
@use 'sass:color';
.producto-equipo-form {
    border-radius: 16px;
    overflow: hidden;

    // Gradiente para el header
    .bg-gradient-primary {
        background: linear-gradient(135deg, var(--q-primary) 0%, color.adjust(#1976d2, $lightness: -10%) 100%);
    }

    // Toolbar fijo arriba
    .toolbar-fixed {
        flex-shrink: 0;
        position: sticky;
        top: 0;
        z-index: 100;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .scroll-area {
        overflow-y: auto;
        max-height: 100%;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;

            &:hover {
                background: #555;
            }
        }
    }

    // Sección de imagen
    &__image-section {
        border-radius: 12px;
        overflow: hidden;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
    }
}

// Sticky summary en desktop
.sticky-summary {
    position: sticky;
    top: 20px;
}

// Card de resumen
.summary-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

// Filas del resumen
.summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    gap: 16px;

    &:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }

    span:first-child {
        flex: 1;
    }

    span:last-child {
        text-align: right;
        word-break: break-word;
    }
}

// Backdrop blur effect
.backdrop-blur {
    backdrop-filter: blur(8px);
}

// Badge de ayuda
kbd {
    background: #f4f4f4;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 2px 6px;
    font-family: monospace;
    font-size: 0.85em;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

// Expansion items
:deep(.q-expansion-item) {
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &.q-expansion-item--expanded {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .q-expansion-item__container {
        .q-item {
            min-height: 56px;
        }
    }
}

// Mejora de tipografía
.text-white-7 {
    color: rgba(255, 255, 255, 0.7);
}

// Responsive
@media (max-width: 1023px) {
    .producto-equipo-form {
        border-radius: 0;
    }

    .sticky-summary {
        position: relative;
        top: 0;
    }
}

// Animaciones
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
